import axios from "axios";
import {Keys} from '/src/config.js'

axios.defaults.baseURL = "https://school.cybenkotechnologies.in/backend/api";//"https://vuejs.bellway.site/backend/api"; //"http://127.0.0.1:8000/api"// // change this if you want to use a different url for APIs
//axios.defaults.withCredentials = true;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('freshToken');
